import Http from '../http'

export default {

  showByCompany(company_id, kind, params) {
    return Http.get(`/companies/${company_id}/dashboards/${kind}`, {
      params: {...params}
    });
  },

  show(kind) {
    return Http.get(`/dashboards/${kind}`, {
      params: {...params}
    });
  },
}